import styled from 'styled-components';

/* ── Page Layout ── */

export const ProfilePageWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${(p) => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? '#ffffff'};
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);
`;

export const ProfileTableWrapperStyled = styled.div`
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

/* Scrollable area for the table rows — takes remaining space above the footer */
export const ProfileTableScrollAreaStyled = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;

  .ant-table-tbody > tr > td {
    padding: 20px 16px;
    font-size: 14px;
    line-height: 1.8;
  }

  .ant-table-thead > tr > th {
    padding: 18px 16px;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }
`;

/* Fixed pagination footer — always anchored at the bottom */
export const ProfilePaginationFooterStyled = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid ${(p) => p.theme?.colors?.border ?? '#f0f0f0'};
  background: ${(p) => p.theme?.colors?.white ?? '#ffffff'};
`;

/* ── Drawer: Entitlement Table ── */

export const EntitlementListWrapperStyled = styled.div`
  .entitlement-group-row {
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: ${(p) => p.theme?.colors?.hoverBg ?? 'rgba(0, 128, 128, 0.04)'};
    }
  }
`;

/* ── Drawer: Header Row (Select all / Remove all + profile selector) ── */

export const DrawerHeaderRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

/* ── Drawer: Profile Description Block (Jobs Library only) ── */

export const DescriptionBlockStyled = styled.div`
  margin-bottom: 16px;

  .description-value {
    margin-top: 4px;
  }

  .ant-input {
    margin-top: 8px;
  }
`;

/* ── Drawer: Access Selectors (Jobs Library only) ── */

export const AccessSelectorsWrapperStyled = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AccessRowStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  .access-label {
    min-width: 180px;
    flex-shrink: 0;
  }

  .access-hint {
    font-size: 12px;
  }

  .ant-select {
    flex: 1;
  }
`;

/* ── Table: Edit icon ── */

export const EditIconStyled = styled.span`
  color: ${(p) => p.theme?.colors?.iconMuted ?? '#8F95B2'};
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${(p) => p.theme?.colors?.primary ?? '#008080'};
  }
`;

/* ── Drawer: Profile Select dropdown ── */

export const PROFILE_SELECT_WIDTH = 250;

/* ── Drawer: Loading container ── */

export const DrawerLoadingStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;
